import React, { Component } from 'react'

import { Row, Content } from '../components/Layout'
import Card from '../components/Card'
import Footer from '../components/Footer'
import Particles from 'react-particles-js'
import '../styles/intro.css'

import 'gsap'
import ScrollMagic from 'ScrollMagic'
import 'animation.gsap'
import 'ScrollToPlugin'
import Bowser from 'bowser'

/* global TweenLite, TimelineMax, Power3 */

const cards = [
  {
    icon: 'ac-neuron',
    header: 'Life @bronzelabs.',
    text:
      'Our mission is to continually adopt new and innovative technologies to build something better in a world that’s becoming ever reliant on data and connectivity.',
    url: '/about'
  },
  {
    icon: 'ac-graduation-hat',
    header: 'Careers.',
    text:
      'We’re always looking for talented, versatile and passionate people itching to bring their ideas into the universe.',
    url: '/careers'
  }
]

const textRotations = {
  capture: [
    'capture',
    'store',
    'operate',
    'humanise',
    'understand',
    'visualise'
  ],
  connect: ['people', 'machines', 'devices', 'things', 'data'],
  standard: [
    'standard',
    'framework',
    'workforce',
    'community',
    'ecosystem',
    'world'
  ]
}

class Home extends Component {
  componentDidMount () {
    if (Bowser.msie) {
      const Intro = document.getElementById('introheadline')
      Intro.classList.add('ie')
    }
    const controller = new ScrollMagic.Controller()
    const animationElements = ['#first-hex', '#second-hex']
    const animationSteps = ['#two', '#three', '#four']

    // Hex animations
    animationElements.map((element, i) => {
      animationSteps.map((step, j) => {
        const x = `${((j % 2) + 1) * 45}%`
        const y = `${j === 1 ? 20 : 0}%`
        const scale = 1 || (j % 2) * -1 + 2
        const rotation = false || (i - 1) * 30 + 20 * j

        new ScrollMagic.Scene({
          triggerElement: step,
          triggerHook: 1,
          duration: window.innerHeight
        })
          .setTween(element, 0.5, { x, y, scale, rotation, force3D: true })
          .addTo(controller)
      })
    })

    // animated connect text
    function changeText (container) {
      const group = container.getAttribute('data-group')
      const randomIndex = Math.floor(
        textRotations[group].length * Math.random()
      )
      const word = textRotations[group][randomIndex]
      container.innerText = word
    }

    const options = {
      start: {
        opacity: 0,
        y: -40,
        ease: Power3.easeOut
      },
      middle: {
        y: 0
      },
      end: {
        opacity: 0,
        y: 40,
        ease: Power3.easeIn
      }
    }
    const containers = document.querySelectorAll('.rotateText')

    Array.prototype.forEach.call(containers, function (container, index) {
      const timeline = new TimelineMax({
        repeat: -1,
        delay: index
      })
      timeline
        // animate each of the letters, with an 800ms animation duration, stagger letters with a 0ms delay
        // easing and transitions are set within options objects above
        .from(container, 0.8, options.start)
        // before transitioning out letters, hold for 2 seconds
        .fromTo(container, 0.2, options.middle, options.end, '=+2')
        .call(changeText, [container])
    })
  }

  scrollToBottom () {
    TweenLite.to(window, 1.2, {
      ease: Power3.easeOut,
      scrollTo: {
        y: document.getElementById('five').offsetTop - 60,
        autoKill: false
      }
    })
  }

  render () {
    return (
      <div className='mainContainer' id='intro'>
        <div id='skip' onClick={() => this.scrollToBottom()}>
          &nbsp;Skip
        </div>
        <div id='particles-bg'>
          <Particles
            width='100vw'
            height='100vh'
            params={{
              particles: {
                number: {
                  value: 30,
                  density: {
                    enable: true,
                    value_area: 400
                  }
                },
                opacity: {
                  value: 1,
                  random: false,
                  anim: {
                    enable: false,
                    speed: 1,
                    opacity_min: 0.1,
                    sync: false
                  }
                },
                size: {
                  value: 1,
                  random: true,
                  anim: {
                    enable: true,
                    speed: 10,
                    size_min: 0.1,
                    sync: false
                  }
                },
                line_linked: {
                  enable: true,
                  distance: 200,
                  color: '#00b1ff',
                  opacity: 1,
                  width: 1
                },
                move: {
                  enable: true,
                  speed: 2,
                  direction: 'bottom',
                  random: true,
                  straight: true,
                  out_mode: 'out',
                  bounce: false
                }
              },
              retina_detect: false
            }}
          />
        </div>
        <div id='particles-bg-blur'>
          <Particles
            width='100vw'
            height='100vh'
            params={{
              particles: {
                number: {
                  value: 30,
                  density: {
                    enable: true,
                    value_area: 1000
                  }
                },
                opacity: {
                  value: 1,
                  random: false,
                  anim: {
                    enable: false,
                    speed: 1,
                    opacity_min: 0.1,
                    sync: false
                  }
                },
                size: {
                  value: 1,
                  random: true,
                  anim: {
                    enable: true,
                    speed: 20,
                    size_min: 0.1,
                    sync: false
                  }
                },
                line_linked: {
                  enable: true,
                  distance: 200,
                  color: '#00b1ff',
                  opacity: 1,
                  width: 1
                },
                move: {
                  enable: true,
                  speed: 2,
                  direction: 'bottom',
                  random: true,
                  straight: true,
                  out_mode: 'out',
                  bounce: false
                }
              },
              retina_detect: false
            }}
          />
        </div>
        <section className='intro main'>
          <div className='mask' />
          <div id='first-hex' className='backgroundHex' />
          <div id='second-hex' className='backgroundHex' />
          <h1 id='introheadline'>
            <strong>Applied</strong>
            <br />
            Research
            <div className='scrollDown buttonHex'>
              <i className='ac ac-arrow-down' />
            </div>
          </h1>
        </section>
        <section id='two' className='intro'>
          <h2>
            We help people
            <div className='rotateTextContainer'>
              <div className='rotateText' data-group='capture'>
                capture
              </div>
            </div>
            data
          </h2>
        </section>
        <section id='three' className='intro'>
          <h2>
            We connect
            <div className='rotateTextContainer'>
              <div className='rotateText' data-group='connect'>
                devices
              </div>
            </div>
            with
            <div className='rotateTextContainer'>
              <div className='rotateText' data-group='connect'>
                things
              </div>
            </div>
          </h2>
        </section>
        <section id='four' className='intro heroContainer'>
          <h2>
            We help build a better
            <div className='rotateTextContainer'>
              <div className='rotateText' data-group='standard'>
                world
              </div>
            </div>
          </h2>
        </section>
        <section id='five' className='noVerticalPadding'>
          <Row>
            <Content>
              <h2>
                We are <strong>bronze</strong> labs.
              </h2>
            </Content>
          </Row>
          <Row>
            <Content>
              <p>
                Founded in 2011, we started a journey that would transform the
                way organisations manage assets and data. Today, our Internet of
                Things (IoT) technologies are deployed in critical situations
                for, commercial, government, non-profit and military
                organisations.
              </p>
            </Content>
            <Content>
              <p>
                We are a proven, multi-award winning UK based innovative
                technologies firm offering scalable, real-time enterprise and
                research and development solutions for organisations with a
                requirement to aggregate Big Data across the Internet of Things
                (IoT) and Smart Cities.
              </p>
            </Content>
          </Row>
          <Row>
            <Content classes={['contentFull']}>
              <p className='noTopMargin'>
                We believe deeply in the power to embrace and drive change. We
                pride ourselves on our ability not only to adopt new and
                innovative technologies but also the desire within our team to
                push back boundaries and understand how we can continue to
                develop and pioneer the future, solving real world problems.
              </p>
            </Content>
          </Row>
        </section>

        <section id='six' className='noTopPadding'>
          <Row>
            {cards.map((card, index) => (
              <Content key={index}>
                <Card options={card} />
              </Content>
            ))}
          </Row>
        </section>
        <a href='https://socialtechtrust.org/' rel='noopener' target='_blank'>
          <img
            id='social-tech-trust'
            src='https://storage.googleapis.com/bronze-labs-static/stt-splash.png'
          />
        </a>
        <Footer />
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/containers/Home.js